import { styled } from '@linaria/react';

import Paper from '@/components/Paper';
import Spinner from '@/components/Spinner';

function ProfileLoader(props: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <Wrapper {...props}>
      <Spinner />
    </Wrapper>
  );
}

const Wrapper = styled(Paper)`
  flex: 1;
  height: 300px;
  display: grid;
  place-content: center;
  border-radius: 8px;
  background: white;
  box-shadow:
    0px 1px 2px hsl(0deg 0% 0% / 0.1),
    0px 2px 4px hsl(0deg 0% 0% / 0.1),
    0px 5px 10px hsl(0deg 0% 0% / 0.1),
    0px 16px 32px hsl(0deg 0% 0% / 0.1);
`;

export default ProfileLoader;
